module.exports = __webpack_public_path__ + "static/media/sign-in-alt.42bde98b.svg";